import css from "styled-jsx/css";
import { rdcUiTheme } from "@rdc-npm/rdc-ui";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";
  .sticky-contact .preview-contact-number,
  .sticky-share .preview-contact-number {
    margin-top: 5px;
  }
  .preview-contact-number {
    padding-left: 34px;
    margin-top: 19px;
    cursor: pointer;
    font-size: 15px;
  }
  .preview-contact-number p {
    margin: 0 0 10px;
  }
  .preview-contact-number a {
    text-decoration-line: underline;
    font-size: 16px;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    color: ${rdcUiTheme.color.interactive.primary.default.initial};
    :hover,
    focus {
      color: ${rdcUiTheme.color.interactive.primary.default.hover};
    }
  }

  .mobile-number {
    color: $gray-light;
  }
  .sticky-share {
    position: absolute;
    top: 54px;
    right: -24px;
    font-size: 15px;
  }
  .icon-number-text {
    height: 24px;
    width: 24px;
    max-width: 100%;
    float: left;
    margin-top: 5px;
  }
  .icon-number-text img {
    opacity: 0.5;
  }
  #exceptHeader {
    margin-top: -2px;
  }

  // Screen width under 650
  @media only screen and (max-width: 650px) {
    .preview-contact-number {
      margin-bottom: 24px;
    }
  }
`;
